// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 689 ? "b536a0f1" : chunkId) + "." + {"157":"e3d5c7207eaca783","689":"0a62d9707289c6da"}[chunkId] + ".js";
};